import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { endOfDay, endOfMonth, endOfWeek, endOfYear, startOfDay, startOfMonth, startOfWeek, startOfYear, subDays, subMonths, subWeeks, } from "date-fns";
import { DateHourInput, InputsArea, OptionsList } from "./styles";
import { DateInput, TimeInput } from "../../Calendar/CalendarComponents";
export var CalendarInputs = function (_a) {
    var selectedDate = _a.selectedDate, setSelectedDate = _a.setSelectedDate;
    return (_jsx(InputsArea, { children: _jsxs(DateHourInput, { children: [_jsx(DateInput, { value: selectedDate, setValue: function (e) {
                        setSelectedDate(e);
                    } }), _jsx(TimeInput, { value: selectedDate, setValue: function (e) {
                        setSelectedDate(e);
                    } })] }) }));
};
export var OPTIONS_FUNCTIONS = {
    Hoje: function () { return ({
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
    }); },
    Ontem: function () {
        var yesterday = subDays(new Date(), 1);
        return {
            start: startOfDay(yesterday),
            end: endOfDay(yesterday),
        };
    },
    "Essa semana": function () { return ({
        start: startOfWeek(new Date()),
        end: endOfWeek(new Date()),
    }); },
    "Semana passada": function () {
        var lastWeek = subWeeks(new Date(), 1);
        return {
            start: startOfWeek(lastWeek),
            end: endOfWeek(lastWeek),
        };
    },
    "Esse mês": function () { return ({
        start: startOfMonth(new Date()),
        end: endOfMonth(new Date()),
    }); },
    "Mês passado": function () {
        var lastMonth = subMonths(new Date(), 1);
        return {
            start: startOfMonth(lastMonth),
            end: endOfMonth(lastMonth),
        };
    },
    "Esse ano": function () { return ({
        start: startOfYear(new Date()),
        end: endOfYear(new Date()),
    }); },
};
export var CalendarOptions = function (_a) {
    var hideOptions = _a.hideOptions, setSelectedDate = _a.setSelectedDate, handleSelectDate = _a.handleSelectDate;
    return (_jsx(OptionsList, { children: Object.keys(OPTIONS_FUNCTIONS)
            .filter(function (option) {
            return !hideOptions.includes(option);
        })
            .map(function (option) {
            return (_jsx("li", { onClick: function () {
                    // setHoveredDays([]);
                    setSelectedDate(OPTIONS_FUNCTIONS[option]());
                    handleSelectDate(OPTIONS_FUNCTIONS[option]());
                }, children: option }));
        }) }));
};
//# sourceMappingURL=index.js.map